/* AUTO-GENERATED icon registry — only the icons the app actually uses, so
   Rollup can tree-shake the rest of lucide-react out of the bundle.
   Regenerate: grep icon names from src, map kebab→Pascal. */
import {
  Activity,
  Armchair,
  ArrowLeftRight,
  ArrowUpCircle,
  ArrowUpRight,
  AtSign,
  Award,
  BadgeCheck,
  BarChart3,
  Bell,
  BellRing,
  BookOpen,
  Bookmark,
  BookmarkCheck,
  Box,
  Brain,
  BrainCircuit,
  Briefcase,
  Building2,
  Calendar,
  Check,
  CheckCheck,
  ChevronDown,
  ChevronRight,
  ChevronsUpDown,
  Cpu,
  Hash,
  Image,
  Clock,
  Compass,
  Copy,
  CornerDownLeft,
  CornerDownRight,
  CreditCard,
  Database,
  Dot,
  Download,
  FileLock2,
  FileText,
  Flag,
  Flame,
  Footprints,
  Gauge,
  GitBranch,
  GitPullRequest,
  Github,
  GraduationCap,
  GripVertical,
  Hammer,
  History,
  IdCard,
  KeyRound,
  Keyboard,
  Layers,
  Layout,
  LayoutDashboard,
  LayoutGrid,
  LifeBuoy,
  LineChart,
  ListChecks,
  Megaphone,
  Loader,
  Lock,
  LogOut,
  Mail,
  Menu,
  MessageCircleQuestion,
  MessageSquare,
  MessageSquareHeart,
  MessageSquareQuote,
  Mic,
  MonitorSmartphone,
  MoreHorizontal,
  OctagonX,
  Palette,
  PanelTop,
  Pause,
  PenLine,
  Pencil,
  PieChart,
  Play,
  Plus,
  Receipt,
  RefreshCw,
  RotateCcw,
  Route,
  Scale,
  Search,
  Settings,
  Shield,
  ShieldCheck,
  Slack,
  SlidersHorizontal,
  Sparkles,
  StickyNote,
  SunMoon,
  Tag,
  Target,
  Telescope,
  Trash2,
  TrendingUp,
  Trophy,
  User,
  UserPlus,
  UserRound,
  Users,
  Wallet,
  Wand2,
  Wrench,
  X,
  Zap,
  Circle,
} from "lucide-react";

import type { ComponentType } from "react";

export const FallbackIcon = Circle;

export const ICON_REGISTRY: Record<string, ComponentType<any>> = {
  "activity": Activity,
  "armchair": Armchair,
  "arrow-left-right": ArrowLeftRight,
  "arrow-up-circle": ArrowUpCircle,
  "arrow-up-right": ArrowUpRight,
  "at-sign": AtSign,
  "award": Award,
  "badge-check": BadgeCheck,
  "bar-chart-3": BarChart3,
  "bell": Bell,
  "bell-ring": BellRing,
  "book-open": BookOpen,
  "bookmark": Bookmark,
  "bookmark-check": BookmarkCheck,
  "box": Box,
  "brain": Brain,
  "brain-circuit": BrainCircuit,
  "briefcase": Briefcase,
  "building-2": Building2,
  "calendar": Calendar,
  "check": Check,
  "check-check": CheckCheck,
  "chevron-down": ChevronDown,
  "chevron-right": ChevronRight,
  "chevrons-up-down": ChevronsUpDown,
  "cpu": Cpu,
  "hash": Hash,
  "image": Image,
  "clock": Clock,
  "compass": Compass,
  "copy": Copy,
  "corner-down-left": CornerDownLeft,
  "corner-down-right": CornerDownRight,
  "credit-card": CreditCard,
  "database": Database,
  "dot": Dot,
  "download": Download,
  "file-lock-2": FileLock2,
  "file-text": FileText,
  "flag": Flag,
  "flame": Flame,
  "footprints": Footprints,
  "gauge": Gauge,
  "git-branch": GitBranch,
  "git-pull-request": GitPullRequest,
  "github": Github,
  "graduation-cap": GraduationCap,
  "grip-vertical": GripVertical,
  "hammer": Hammer,
  "history": History,
  "id-card": IdCard,
  "key-round": KeyRound,
  "keyboard": Keyboard,
  "layers": Layers,
  "layout": Layout,
  "layout-dashboard": LayoutDashboard,
  "layout-grid": LayoutGrid,
  "life-buoy": LifeBuoy,
  "megaphone": Megaphone,
  "line-chart": LineChart,
  "list-checks": ListChecks,
  "loader": Loader,
  "lock": Lock,
  "log-out": LogOut,
  "mail": Mail,
  "menu": Menu,
  "message-circle-question": MessageCircleQuestion,
  "message-square": MessageSquare,
  "message-square-heart": MessageSquareHeart,
  "message-square-quote": MessageSquareQuote,
  "mic": Mic,
  "monitor-smartphone": MonitorSmartphone,
  "more-horizontal": MoreHorizontal,
  "octagon-x": OctagonX,
  "palette": Palette,
  "panel-top": PanelTop,
  "pause": Pause,
  "pen-line": PenLine,
  "pencil": Pencil,
  "pie-chart": PieChart,
  "play": Play,
  "plus": Plus,
  "receipt": Receipt,
  "refresh-cw": RefreshCw,
  "rotate-ccw": RotateCcw,
  "route": Route,
  "scale": Scale,
  "search": Search,
  "settings": Settings,
  "shield": Shield,
  "shield-check": ShieldCheck,
  "slack": Slack,
  "sliders-horizontal": SlidersHorizontal,
  "sparkles": Sparkles,
  "sticky-note": StickyNote,
  "sun-moon": SunMoon,
  "tag": Tag,
  "target": Target,
  "telescope": Telescope,
  "trash-2": Trash2,
  "trending-up": TrendingUp,
  "trophy": Trophy,
  "user": User,
  "user-plus": UserPlus,
  "user-round": UserRound,
  "users": Users,
  "wallet": Wallet,
  "wand-2": Wand2,
  "wrench": Wrench,
  "x": X,
  "zap": Zap,
};
